import { combineReducers } from "redux";

import forgotPasswordCode from '../pages/ForgotPasswordCode/forgot-password-code';
import forgotPassword from '../pages/ForgotPassword/forgot-password';

import signIn from '../pages/SignIn/sign-in';
import signUp from "../pages/SignUp/sign-up";

import verify from "../pages/Verify/verify";

import userInformation from '../pages/Settings/UserInformation/user-information'
import updateYourEmail from '../pages/Settings/UpdateYourEmail/update-your-email'
import setNewPassword from '../pages/Settings/SetNewPassword/set-new-password'
import dashboard from '../pages/Dashboard/dashboard'

import history from '../history'


import { createRouterReducer } from '@lagunovsky/redux-react-router'

import feedback from '../components/Feedback/feedback';
import app from "../App/app";
import logout from "../pages/Logout/logout";
import customSSO from "../pages/CustomSSO/custom-sso";


const settings = combineReducers( {
  userInformation,
  updateYourEmail,
  setNewPassword,
});

const pages = combineReducers( {
  forgotPassword,
  verify,
  forgotPasswordCode,
  settings,
  signIn,
  signUp,
  logout,
  customSSO,
  dashboard,
});

const router = createRouterReducer( history );

export default combineReducers({
  router,
  app,
  feedback,
  pages,
});

// https://github.com/Development-Person/reduxstarter/blob/master/src/store
